module.exports = __webpack_public_path__ + "img/arrow_down_grey.456527e9.svg";